// libraries
import React, { useState, FormEvent } from 'react'

// components
import Section from '/react4xp/components/Section'
import Button from '/react4xp/components/Button'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils'

// props
export interface NewsletterProps {
    color?: 'primary' | 'secondary'
    title?: string
    description?: string
    serviceUrl?: string
    form?: {
        placeholder?: string
        submitLabel: string
    }
}

export default function Newsletter({
    color = 'primary',
    title = 'Nyhetsbrev',
    description = 'Motta det ukentlige nyhetsbrevet vårt!',
    serviceUrl,
    form = {
        placeholder: 'Din e-post',
        submitLabel: 'Meld deg på'
    }
}: NewsletterProps) {
    const [email, setEmail] = useState('')
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [message, setMessage] = useState<string>('')

    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        
        if (!serviceUrl) {
            console.error('Newsletter: serviceUrl is required for form submission')
            return
        }

        setIsSubmitting(true)
        setMessage('')

        try {
            const response = await fetch(serviceUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email })
            })

            const data = await response.json()

            if (response.status === 200) {
                setEmail('')
            }

            // Display message from backend
            if (data.message) {
                setMessage(data.message)
            }
        } catch (error) {
            setMessage('Noe gikk galt. Prøv igjen senere.')
            console.error('Newsletter submission error:', error)
        } finally {
            setIsSubmitting(false)
        }
    }
    return (
        <Section
            id='newsletter'
            bgColor={color === 'primary' ? 'primary' : 'secondary'}
            paddingTop='big'
            paddingBottom='big'
            className={color === 'primary' ? 'primary' : 'secondary'}
        >
            <div className='container'>
                <div className='flex'>

                    {isNonWhitespaceString(title) && (
                        <h2 className='h2 white'>
                            {title}
                        </h2>
                    )}

                    {isNonWhitespaceString(description) && (
                        <p className='ingress white'>
                            {description}
                        </p>
                    )}

                    <form className='form' onSubmit={handleSubmit} data-newsletter-service-url={serviceUrl}>

                        <input
                            type='email'
                            name='newsletterFormInputEmail'
                            placeholder={form.placeholder}
                            required
                            className='p1 input'
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            disabled={isSubmitting}
                            aria-label={form.placeholder}
                        />

                        <Button
                            type='submit'
                            style='solid'
                            color={color === 'primary' ? 'secondary' : 'primary'}
                            small
                            disabled={isSubmitting}
                        >
                            {form.submitLabel}
                        </Button>

                    </form>

                    {message && (
                        <p className='white' style={{ marginTop: '1rem' }}>
                            {message}
                        </p>
                    )}
                
                </div>
            </div>
        </Section>
    )
}